import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NonWorkingHours = ({ open, navigate }: { open: boolean; navigate: VoidFunction }) => {
  const { t } = useTranslation('onboarding');

  return (
    <Dialog open={open}>
      <DialogContent>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <img
            src='/images/digital_account/non_working_info.png'
            alt='non working hour'
            width={64}
            height={64}
          />
          <Typography fontSize={28} lineHeight={2} fontWeight={'bold'} align='center'>
            {t('non_working_hours')}
          </Typography>
          <Typography fontSize={16} lineHeight={1.4} align='center'>
            {t('non_working_hours_description')}
          </Typography>
          <Button sx={{ width: '100%', mt: 3, height: 56 }} color='secondary' onClick={navigate}>
            {t('back_to_home_page')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NonWorkingHours;
